import { IconButton } from '@seller/ui/Button';
import { AdminTheme } from '../theme';

interface ThemeToggleButtonProps {
  onClick: () => void;
  theme: AdminTheme;
}

export function ThemeToggleButton({ onClick, theme }: ThemeToggleButtonProps) {
  return (
    <IconButton
      aria-label={theme === 'dark' ? 'Включить светлую тему' : 'Включить темную тему'}
      aria-pressed={theme === 'light'}
      className="admin-theme-switch"
      onClick={onClick}
      type="button"
    >
      <span className="admin-theme-switch__icon" aria-hidden="true">
        ◐
      </span>
      <span className="admin-theme-switch__icon" aria-hidden="true">
        ☀
      </span>
      <span className="admin-theme-switch__thumb" aria-hidden="true" />
    </IconButton>
  );
}
